import IMG1 from '../../assets/notes_project.jpg'
import IMG2 from '../../assets/todo_project.jpg'
import IMG3 from '../../assets/Pr_company.png'
import IMG4 from '../../assets/Clock_project.jpg'
import IMG5 from '../../assets/Car_project.jpg'
const projectData = [

    {
        id:1,
        image: IMG1,
        title:'Keep Notes App',
        github: 'https://github.com/Kishandixit/keepnotes.git',
        demo:'https://kishandixit.github.io/keepnotes/'
    },
    {
        id:2,
        image: IMG2,
        title:'TODO List App',
        github: 'https://github.com/Kishandixit/todo-list-app.git',
        demo:'https://kishandixit.github.io/todo-list-app/'
    },
    
    {
        id:3,
        image: IMG3,
        title:'PR company website',
        github: 'https://github.com/Kishandixit/Brainy_Bunch_PR_Company.git',
        demo:'https://kishan-pr-company.netlify.app'
    },
    {
        id:4,
        image: IMG4,
        title:'Analog Clock',
        github: 'https://github.com/Kishandixit/Analog-clock.git',
        demo:'https://myanalog-clock.netlify.app'
    },
    {
        id:5,
        image: IMG5,
        title:'Car Game',
        github: 'https://github.com/Kishandixit/Car-Game-Project.git',
        demo:'https://myracing-car.netlify.app'
    },
]
export default projectData;